import { Box, IconButton, Typography } from '@mui/material';
import Page from 'src/components/Page';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ProjectBasicForm from 'src/layouts/ProjectComponents/ProjectBasicForm';
import palette from 'src/theme/palette';

export default function AddProject() {
  const location = useLocation();
  const { projectData } = location.state || {};
  const navigate = useNavigate();

  return (
    <Page title={`${projectData ? 'Edit-Job' : 'Add-Job'} | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 2,
          padding: '0 10px'
        }}
      >
        {/* Back Button */}
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            color: '#000',
            mr: 1,
            p: 0.5,
            '&:hover': {
              backgroundColor: 'transparent',
              color: palette.primary.main
            }
          }}
        >
          <ArrowBackIcon sx={{ fontSize: 24 }} />
        </IconButton>

        {/* Heading */}
        <Typography
          sx={{
            fontSize: 25,
            fontFamily: 'poppinsSemiBold'
          }}
        >
          {projectData ? 'Edit Job' : 'Add Job'}
        </Typography>
      </Box>

      <ProjectBasicForm editData={projectData} />
    </Page>
  );
}
